import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../providers/globals';

@Component({
  selector: 'page-business-message-detail-image',
  templateUrl: 'business-message-detail-image.html',
})
export class BusinessMessageDetailImagePage {
	imageSrc: any

  constructor(
  	public navCtrl: NavController, 
  	public navParams: NavParams,
  	public globals: Globals) {

  	this.imageSrc = this.navParams.get('imageSrc')
  }
}



// WEBPACK FOOTER //
// ./src/pages/business-message-detail-image/business-message-detail-image.ts